import { PropsWithChildren } from 'react';

import { globalColors, TThemeColours } from '@pb/styles';

const transparentButtonStyles = [
    'transparentPurple',
    'transparentIndigo',
    'transparentBlack',
    'transparentPink',
    'transparentYellow',
    'transparentGreen',
    'transparentOrange',
    'transparentDarkPurple',
    'transparentTeal',
    'transparentWhite',
] as const;

const transparentBorderedButtonStyles = [
    'transparentBorderedPurple',
    'transparentBorderedIndigo',
    'transparentBorderedBlack',
    'transparentBorderedPink',
    'transparentBorderedYellow',
    'transparentBorderedGreen',
    'transparentBorderedOrange',
    'transparentBorderedDarkPurple',
    'transparentBorderedTeal',
    'transparentBorderedWhite',
] as const;

export const buttonColors = [
    ...globalColors,
    ...transparentButtonStyles,
    ...transparentBorderedButtonStyles,
] as const;

export type TButtonColors = typeof buttonColors[number];

export type TButtonProperties = {
    /**
     * The colour of the button.
     */
    color?: TButtonColors;

    /**
     * Should the button take up the full width of the containing element.
     */
    fullWidth?: boolean;

    /**
     * Should the button take up the full width of the containing element on a mobile device; this will override what the `fullWidth` property does
     */
    fullWidthOnMobileOnly?: boolean;

    /**
     * The location you should go to when clicking on the button.
     */
    to?: string;

    /**
     * Where to display the linked URL.
     */
    target?: string;

    /**
     * Should the button be disabled.
     */
    disabled?: boolean;

    /**
     * Should the button be disabled.
     */
    onClick?: (event: React.MouseEvent) => void;

    /**
     * Used to allow extending components to override the styles in this component.
     */
    className?: string;

    [x: string]: any;
};

export type TStyledButtonProperties = {
    buttonColor: TButtonColors;
    disabled: boolean;
    fullWidth?: boolean;
    fullWidthOnMobileOnly?: boolean;
};

export type TMappedButtonColors = {
    backgroundColor: string;
    borderColor: string;
    textColor: string;
};

export type TButtonStyle = {
    name: string;
    backgroundColor: TThemeColours | 'transparent';
    borderColor: TThemeColours | 'transparent';
    color: TThemeColours;
};

export type TSanityButtonProperties = Pick<
    PropsWithChildren<TButtonProperties>,
    'children' | 'color' | 'to'
>;
